import { useLocation } from 'react-router-dom'

import { ADMIN_PATH } from '~/redux-modules/preferences'

export default function useIsAdminPage() {
    const { pathname } = useLocation()

    return pathname.includes(ADMIN_PATH)
}
